
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function FirePumpSetsPage() {
  const product = {
    id: 8,
    title: 'Fire Pump Sets',
    category: 'Fire Suppression Systems',
    brand: 'FlameGuardQA',
    model: 'FG-FPS-01',
    certification: 'NFPA 20 Standard',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20industrial%20fire%20pump%20system%20with%20electric%20motor%20and%20control%20panel%2C%20NFPA%2020%20compliant%20fire%20suppression%20pump%20equipment%20with%20pressure%20gauges%20and%20QCDD%20certification%20in%20Qatar%20fire%20station%20with%20technical%20specifications%20and%20safety%20features&width=600&height=600&seq=fire-pump-system-detail&orientation=squarish',
    description: 'Electric and diesel-driven fire pump systems designed per NFPA 20 for consistent pressure in sprinkler and hydrant networks. These reliable pump sets ensure adequate water supply and pressure for fire protection systems.'
  };

  const features = [
    'Electric or diesel-driven main pump',
    'Jockey pump for pressure maintenance',
    'Automatic start control panel',
    'Skid-mounted or packaged units',
    'NFPA 20 compliant design',
    'Pressure monitoring systems',
    'Emergency backup capabilities',
    'Remote monitoring options'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-FPS-01' },
    { label: 'Type', value: 'Electric/Diesel Fire Pump Set' },
    { label: 'Flow Rate', value: 'Custom (as per project)' },
    { label: 'Head Pressure', value: '40–120m' },
    { label: 'Motor Power', value: '10HP–150HP' },
    { label: 'Main Pump', value: 'Centrifugal End Suction' },
    { label: 'Jockey Pump', value: 'Vertical Multistage' },
    { label: 'Control Panel', value: 'Automatic Start/Stop' },
    { label: 'Mounting', value: 'Skid-mounted/Packaged' },
    { label: 'Material', value: 'Cast Iron/Stainless Steel' },
    { label: 'Certification', value: 'QCDD, NFPA 20' },
    { label: 'Warranty', value: '2 Years' }
  ];

  const relatedProducts = [
    {
      id: 7,
      title: 'Sprinkler Heads & Systems',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20heads%20installed%20in%20white%20ceiling%20with%20red%20pipes%20and%20brass%20fittings%2C%20UL%20listed%20sprinkler%20system%20with%20various%20temperature%20ratings%20and%20spray%20patterns%20in%20Qatar%20commercial%20building&width=300&height=200&seq=sprinkler-heads-related&orientation=landscape',
      category: 'Sprinklers',
      compliance: 'UL Listed'
    },
    {
      id: 9,
      title: 'Control Valves & Accessories',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20control%20valves%20and%20butterfly%20valves%20with%20red%20handles%20and%20brass%20fittings%2C%20FM%20approved%20flow%20control%20devices%20for%20fire%20suppression%20systems%20with%20technical%20specifications&width=300&height=200&seq=control-valves-related2&orientation=landscape',
      category: 'Valves',
      compliance: 'FM Approved'
    },
    {
      id: 13,
      title: 'Fire Hydrant Systems',
      image: 'https://readdy.ai/api/search-image?query=Red%20fire%20hydrant%20system%20with%20hose%20reel%20and%20landing%20valve%20in%20protective%20cabinet%2C%20professional%20fire%20fighting%20equipment%20with%20QCDD%20approval%20in%20Qatar%20commercial%20building&width=300&height=200&seq=hydrant-system-related2&orientation=landscape',
      category: 'Hydrants',
      compliance: 'BS Standards'
    },
    {
      id: 1,
      title: 'Fire Alarm Control Panel',
      image: 'https://readdy.ai/api/search-image?query=Professional%20intelligent%20fire%20alarm%20control%20panel%20with%20digital%20LCD%20display%20and%20red%20indicator%20lights%2C%20advanced%20addressable%20fire%20detection%20system%20with%20network%20connectivity%20and%20QCDD%20approval&width=300&height=200&seq=alarm-control-panel-related4&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'QCDD Approved'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
